<template>
  <div class="alert-box" :class="type">
    <div class="alert-icon">
      <i class="fal" :class="icon"></i>
    </div>
    <div class="alert-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'info',
      validator: prop => ['info', 'warning', 'error', 'success'].includes(prop)
    }
  },

  computed: {
    icon () {
      switch (this.type) {
        case 'info':
        default:
          return 'fa-info'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/styles/common/common';
.alert-box {
  display: flex;
  color: rgba(255, 255, 255, 0.9);
  min-height: 3rem;
  align-items: center;

  .alert-icon {
    flex: 0 0 3rem;
    text-align: center;
    min-height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .alert-text {
    flex: 1;
    padding: 0.5rem 1.5rem;
    min-height: 3rem;
    display: flex;
    align-items: center;
  }

  &.error {
    background-color: $red;

    .alert-text {
      background-color: lighten($red, 20%);
    }
  }

  &.success {
    background-color: $success;
  }

  &.warning {
    background-color: $warning;
  }

  &.info {
    background-color: $onflow-gray;

    .alert-text {
      background-color: lighten($onflow-gray, 20%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/boxes/AlertBox.vue